import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import { AuthService } from '../core/services/AuthService';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        
        const isAuthenticate = this.authService.isAuthenticate();

        if (!isAuthenticate) {            
            this.router.navigate(['auth/login'], {
                queryParams: { 
                    
                },
                queryParamsHandling: 'merge'
            });
            return false;
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        const isAuthenticate = this.authService.isAuthenticate();
        if (!isAuthenticate) {            
            this.router.navigate(['auth/login'], {
                queryParams: { 
                    
                },
                queryParamsHandling: 'merge'
            });
            return false;
        }
    }
}
